<template>
    <a :href="`${docsUrl}/${endpoint}`" target="_blank" >How it works?</a>
</template>

<script>
export default {
    name: "HowItWorks",
    props: {
        endpoint: {
            type: String
        }
    },
    computed: {
        docsUrl() {
            return this.$env.get('DOCS_URL')
        }
    }
}
</script>